import AuthenticatedLayout from '../../Layouts/AuthenticatedLayout';
import RegularButton from '../../Components/RegularButton';
import CreateTenantForm from './Partials/CreateTenantForm';
import { BiExit } from "react-icons/bi";
import { Head } from '@inertiajs/react';

const CreateTenant = ({ auth, status, domain_name }) => {
  return (
    <AuthenticatedLayout
    user={auth.user}
    header="Tenants"
    >
        <Head title="Create Tenant" />

        <div className="py-12">
            <div className="w-full mx-auto px-6 lg:px-12">
                <div className="bg-white overflow-hidden shadow-md sm:rounded-lg">
                    <div className="p-6">

                        <RegularButton
                        href={route('tenants.manage')}
                        className="float-right focus:ring-white"
                        >
                            <BiExit className="h-5 w-auto text-slate-500 hover:text-slate-600 focus:text-slate-700  active:text-slate-800" />
                        </RegularButton>

                        <CreateTenantForm status={status} domain_name={domain_name} />
                    </div>

                </div>
            </div>
        </div>
    </AuthenticatedLayout>
  )
}

export default CreateTenant
